import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.15 Case 15</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_15"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 15. This is a positive case.
                Beginning at the level of the cerebellum and moving superiorly,
                you may notice image noise; however, this scan is still
                interpretable.
              </p>
              <p>
                Moving into the temporal and occipital regions, seen here, white
                matter tracts are not easily delineated on the left or on the
                right. Loss of gray-white contrast is seen bilaterally, as there
                is increased activity in the cortical gray matter. Continuing to
                move superiorly, at this level, white matter tracts are more
                easily identifiable; however, overall, there remains loss of
                gray-white contrast on the left as well as on the right. Looking
                to the prefrontal cortices, seen here, once again, patchy uptake
                is seen in the white matter tracts on the left as well as on the
                right. Less intense activity is seen surrounding these white
                matter tracts. It is always important to ensure that this less
                intense activity corresponds to gray matter.
              </p>
              <p>
                Utilizing the fused images, you can see that this less intense activity actually corresponds to CSF space, seen here, in the left frontal cortex. On the right frontal cortex, a similar, less intense area is also seen, corresponding to a second CSF space. Therefore, this is not preserved gray-white contrast but is in fact due to atrophy. Returning to the PET images and continuing to move superiorly, distinct white matter tracts are identifiable, coursing from the front of the brain to the back of the brain, on the left as well as on the right, although appearing patchy secondary to image noise.
              </p>
              <p>
                Although this scan has image noise and atrophy, it remains positive, as there is loss of gray-white contrast in the frontal cortices as well as in the temporal and occipital regions. If you called this case negative, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-14"
          nextLesson="/module-4/module-4-1-16"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1083313660&entry_id=1_3hw50zmj&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_3hw50zmj"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
